<template>
  <div>
    <div style="margin-bottom: 1rem">
      <label class="common-label-title">{{ appCustomTextConst['Supportive Information'] }}</label>
    </div>

    <div v-for="(ques, quesIndex) in basicQuestions" :set="(v = getQuestionValidator(ques))" :key="`quest-${quesIndex}`">
      <label style="white-space: pre-wrap">{{ ques.optional ? '' : '*' }} {{ quesIndex + 1 + '. ' + ques.APFQ_Desc }}</label>
      <div v-if="ques.APFQ_Type === 'option' || (group === 'MIS' && ['ENFQ202000000443', 'ENFQ202000000997'].includes(ques.APFQ_ID))">
        <select class="form-control" v-model="ques.newAnswer">
          <option value="yes">Yes</option>
          <option value="no">No</option>
        </select>

        <textarea class="form-control" rows="4" v-model="ques.newAnswerValue" v-if="ques.newAnswer === 'yes' && ques.APFQ_ID !== `ENFQ202000000659`"></textarea>
      </div>

      <div v-else-if="ques.APFQ_Type === 'text'">
        <textarea class="form-control" rows="4" v-model="ques.newAnswer"></textarea>
      </div>

      <el-alert
        title="This field is required."
        type="error"
        v-if="v.newAnswer.$error && !v.newAnswer.required"
        style="margin-top: -15px; margin-bottom: 10px"
      ></el-alert>
    </div>

    <div v-if="additionalQuestions && !apfConfig.excludeAdditionQuestion?.includes(group)">
      <hr />
      <div class="header-a"><strong>Additional Information</strong></div>
      <div v-for="(ques, quesIndex) in additionalQuestions" :set="(v = getQuestionValidator(ques))" :key="`ques-${quesIndex}`">
        <label v-text="`${quesIndex + 1}. ${ques.APFQ_Desc}`" style="white-space: pre-wrap"></label>
        <div v-if="ques.APFQ_ID === `ENFQ202000000337`">
          <ApfSchoolBusServiceText :school="school" />
        </div>

        <div v-if="ques.APFQ_Type === 'option'">
          <select class="form-control" v-model="ques.newAnswer">
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </select>
        </div>

        <div v-if="ques.APFQ_Type === 'checkbox'">
          <div class="form-control" v-if="ques.APFQ_ID === `ENFQ202000001001`" style="height: auto; display: flex">
            <input
              :id="ques.APFQ_ID"
              type="checkbox"
              style="margin-bottom: auto; margin-top: 5px; margin-right: 5px"
              :checked="ques.newAnswer === 'Yes'"
              @click="ques.newAnswer = ques.newAnswer === 'Yes' ? '' : 'Yes'"
            />
            <label :for="ques.APFQ_ID" style="line-height: 1.25; font-weight: normal; margin-bottom: 0">
              I acknowledge and grant permission for my child/ward to take part in Physical Education lessons and activities off the school campus for the
              duration of their enrolment at EtonHouse International School Orchard
            </label>
          </div>
        </div>

        <div v-if="ques.APFQ_Type === 'text'">
          <textarea class="form-control" rows="4" v-model="ques.newAnswer"></textarea>
        </div>

        <el-alert
          title="This field is required."
          type="error"
          v-if="v.newAnswer.$error && !v.newAnswer.required"
          style="margin-top: -15px; margin-bottom: 10px"
        ></el-alert>
      </div>
    </div>
  </div>
</template>

<script>
import ApfSchoolBusServiceText from '@/pages/application/texts/ApfSchoolBusServiceText'
import { ehSchoolsData, misQuestionIds, schools } from '../data.js'
import appCustomTextConst from '@/pages/application/const/applicationCustomTextConst'
import apfConfig from '@/pages/application/config/apfConfig'

export default {
  components: { ApfSchoolBusServiceText },
  props: ['group', 'school', 'questions', 'validator', 'hideBusFee'],
  data() {
    return {
      schools,
      appCustomTextConst,
      ehSchools: schools,
      apfConfig,
      ehSchoolsData,
    }
  },
  computed: {
    basicQuestions() {
      if (this.group === 'MIS') {
        return this.questions.filter(ques => misQuestionIds.includes(ques.APFQ_ID))
      }

      if (this.group === 'PRE') {
        let quesList = this.questions.filter((el, idx) => idx < 8)
        quesList[6] = this.questions?.[8]
        quesList[6].APFQ_Type = 'text'
        quesList.push(this.questions?.[9])
        quesList?.map((el, idx) => {
          if (idx === 8) {
            el.optional = true
          }
          return el
        })
        return quesList
      }
      if (this.school === this.ehSchoolsData.Claymore.schoolID) {
        return this.questions.filter((el, idx) => idx < 10).filter(ques => !(['ENFQ202000000115']?.includes(ques.APFQ_ID) && this.school !== 'SCH201300000254'))
      }

      return this.questions.filter((el, idx) => idx < 9).filter(ques => !(ques.APFQ_ID === 'ENFQ202000000659' && this.school !== 'SCH201300000254'))
    },

    additionalQuestions() {
      if (this.group === 'MIS' || this.school === this.ehSchools?.['Claymore']) return null

      if (this.group === 'EH' && this.school === schools.Orchard) return this.questions.filter((el, idx) => idx >= 10 && idx <= 14)

      return this.questions.filter((el, idx) => idx >= 10 && idx <= 12)
    },
  },
  methods: {
    getQuestionValidator(ques) {
      return Object.values(this.validator.$each).filter(q => q?.$model?.APFQ_ID === ques.APFQ_ID)[0]
    },
  },
}
</script>
